import { faFileExport } from "@fortawesome/free-solid-svg-icons"
import HeaderActionConfig from "../HeaderActionConfig"
import { useLanguageContext } from "../../../../../../context/LanguageContext"
import useEvaApi, { EvaApiCall } from "../../../../../../hooks/useEvaApi";

/**
 * @param {string} entity 
 * @param {Function} onExport 
 * @param {string} loadingGroup 
 * @returns {HeaderActionConfig}
 */
function useExportHeaderActionConfig(entity, onExport = null) {
  const callEvaApi = useEvaApi();
  const { translate } = useLanguageContext();
  const loadingGroup = `${entity}_export`;

  async function handleExport(dataTable) {
    callEvaApi(
      new EvaApiCall(`${entity}/export`)
        .setLoadingGroup(loadingGroup)
        .setParams(dataTable.filters)
        .setDownloadAs(entity)
    )
  }

  return new HeaderActionConfig()
    .setIcon(faFileExport)
    .setCallback(onExport || handleExport)
    .setLoadingGroups(loadingGroup)
    .setTitle(
      translate("eva.main.entities.states.export", [
        {
          key: "entities",
          value: translate(`eva.main.entities.${entity}`)
        }
      ])
    )
}

export default useExportHeaderActionConfig;